import { useState, useCallback } from "react";
import type { ReactNode } from "react";
import { HomeHeader } from "@/components/shared/HomeHeader/HomeHeader";
import { HomeNavigations } from "@/components/shared/HomeNavigations/HomeNavigations";
import type { TabId } from "@/components/shared/HomeNavigations/HomeNavigations";
import { NewRequestDialog } from "@/components/shared/NewRequestDialog/NewRequestDialog";
import { MyRequestsPage } from "@/pages/MyRequestsPage/MyRequestsPage";
import { MyApprovalsPage } from "@/pages/MyApprovalsPage/MyApprovalsPage";
import styles from "./HomePage.module.scss";

export function HomePage(): ReactNode {
  const [activeTab, setActiveTab] = useState<TabId>("myRequests");
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const handleOpenDialog = useCallback((): void => {
    setIsDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback((): void => {
    setIsDialogOpen(false);
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.gridContainer}>
        {/* Header section */}
        <div className={styles.top}>
          <HomeHeader />
          <HomeNavigations activeTab={activeTab} onTabChange={setActiveTab} onNewRequest={handleOpenDialog} />
        </div>

        {/* Tab content */}
        <div className={styles.tabPanel} role="tabpanel" aria-label={`${activeTab === "myRequests" ? "My requests" : "My approvals"} content`}>
          {activeTab === "myRequests" && <MyRequestsPage />}
          {activeTab === "myApprovals" && <MyApprovalsPage />}
        </div>
      </div>

      <NewRequestDialog
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
      />
    </div>
  );
}
